import { defineStore } from "pinia";
import axios from "axios";
import { API_URL } from "@/config/api";
import { withShioriAccessContext } from "@/api/shiori-access-context.js";
import { createGuestChecklist, isGuestMode } from "@/utils/guest-session";

export const useChecklistTemplateStore = defineStore("checklistTemplate", {
  state: () => ({
    items: [],
    loading: false,
    error: null,
  }),

  actions: {
    async fetchTemplateItems() {
      this.loading = true;
      this.error = null;
      try {
        if (isGuestMode()) {
          this.items = [];
          return this.items;
        }

        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/checklist_template/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        this.items = response.data;
        return this.items;
      } catch (e) {
        this.error =
          e.response?.data?.detail || "テンプレートの取得に失敗しました";
        throw e;
      } finally {
        this.loading = false;
      }
    },

    async createTemplateItem(itemName, categoryName) {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${API_URL}/checklist_template/`,
        { item_name: itemName, category_name: categoryName || null },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      await this.fetchTemplateItems();
      return response.data;
    },

    async updateTemplateItem(templateNo, itemName, categoryName) {
      const token = localStorage.getItem("token");
      await axios.put(
        `${API_URL}/checklist_template/${templateNo}`,
        { item_name: itemName, category_name: categoryName || null },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      await this.fetchTemplateItems();
    },

    async deleteTemplateItem(templateNo) {
      const token = localStorage.getItem("token");
      await axios.delete(`${API_URL}/checklist_template/${templateNo}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      await this.fetchTemplateItems();
    },

    async copyTemplateToChecklist(shioriId) {
      if (isGuestMode()) {
        [
          ["充電器", "ガジェット"],
          ["着替え", "衣類"],
          ["常備薬", "ヘルスケア"],
        ].forEach(([itemName, categoryName]) => {
          createGuestChecklist(shioriId, "BELONGINGS", {
            itemName,
            categoryName,
          });
        });
        return { message: "テンプレートから持ち物を追加しました" };
      }

      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${API_URL}/checklist_detail/from-template/${shioriId}`,
        {},
        withShioriAccessContext(shioriId, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      );
      return response.data;
    },
  },
});
